import { FC } from 'react'

import InputItem from '../../../../../components/InputItem'
import { ITabBaseProps } from '../types'

// The story's impact columns, all optional. Same set as food's Impacts tab minus the produce-only
// entries, which have no meaning for a material.
export const Impacts: FC<ITabBaseProps> = ({ formik }) => {
  return (
    <div className="mb-5 mt-5">
      <p>Please provide environmental impacts for the functional unit specified.</p>
      <div className="piece-content-inputs mb-5">
        <InputItem
          name="Land Use"
          description="Please provide Land use in m2*year."
          type="input"
          addonTitle="m2*y"
          onChange={formik.handleChange}
          formikName="landUse"
          formik={formik}
          defaultValue={formik.values.landUse === 0 ? '0' : formik.values.landUse ?? ''}
        />
        <InputItem
          name="Eutrophication"
          description="Please provide eutrophication in g PO43- eq."
          type="input"
          addonTitle="g"
          onChange={formik.handleChange}
          formikName="eutrophication"
          formik={formik}
          defaultValue={
            formik.values.eutrophication === 0 ? '0' : formik.values.eutrophication ?? ''
          }
        />
        <InputItem
          name="Biodiversity"
          description="Please provide the Biodiversity impact in sp.yr*10^14."
          type="input"
          addonTitle="sp.yr*10^14"
          onChange={formik.handleChange}
          formikName="biodiversity"
          formik={formik}
          defaultValue={formik.values.biodiversity === 0 ? '0' : formik.values.biodiversity ?? ''}
        />
        <InputItem
          name="Freshwater Withdrawal"
          description="Please provide water usage in L"
          type="input"
          addonTitle="L"
          onChange={formik.handleChange}
          formikName="waterUsage"
          formik={formik}
          defaultValue={formik.values.waterUsage === 0 ? '0' : formik.values.waterUsage ?? ''}
        />
        <InputItem
          name="Freshwater accounting for Water Scarcity"
          description="Please provide water usage including water scarcity conversion in L eq."
          type="input"
          addonTitle="L eq"
          onChange={formik.handleChange}
          formikName="waterUsageIncludingWasterScarcity"
          formik={formik}
          defaultValue={
            formik.values.waterUsageIncludingWasterScarcity === 0
              ? '0'
              : formik.values.waterUsageIncludingWasterScarcity ?? ''
          }
        />
      </div>
    </div>
  )
}
